var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 112,
    viewBox: "0 0 136 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.24611 43.9995C-3.4232 90.9163 34.8004 112 64.9369 112C95.0734 112 134.246 86.6587 134.246 59.6692C134.246 32.6796 127.053 15.8729 96.7376 5.46562C66.4226 -4.94168 3.91542 -2.91726 0.24611 43.9995Z",
    fill: "#F7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40.4167C34 32.5926 40.3426 26.25 48.1667 26.25H87.8333C95.6574 26.25 102 32.5926 102 40.4167V60.25C102 68.074 95.6574 74.4167 87.8333 74.4167H48.1667C40.3426 74.4167 34 68.074 34 60.25V40.4167Z",
    fill: "#E6E5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3886 69.452C56.5583 67.1879 59.501 65.916 62.5694 65.916H79.0972C82.1656 65.916 85.1084 67.1879 87.278 69.452C89.4477 71.716 90.6667 74.7867 90.6667 77.9885V82.3001C90.6667 84.2051 89.1867 85.7494 87.3611 85.7494C86.0089 85.7494 55.6578 85.7494 54.3056 85.7494C52.4799 85.7494 51 84.2051 51 82.3001V77.9885C51 74.7867 52.2189 71.716 54.3886 69.452Z",
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 51.7493C59.5 45.4901 64.5741 40.416 70.8333 40.416C77.0926 40.416 82.1667 45.4901 82.1667 51.7493C82.1667 58.0086 77.0926 63.0827 70.8333 63.0827C64.5741 63.0827 59.5 58.0086 59.5 51.7493Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocker);
export default __webpack_public_path__ + "static/media/blocker.14d993b4388fa8a01de84a2e0d396bb2.svg";
export { ForwardRef as ReactComponent };